import { FC, useState } from 'react';

import { useAuth } from '@shared/state/hooks/useAuth';
import { classNames } from '@shared/utils/joinClassNamesUtils';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { name: '주문 배송관리', href: '/gift-brand/delivery' },
  { name: '과거 배송검색', href: '/gift-brand/delivery-search' },
  { name: '정산 관리', href: '/gift-brand/settlement' },
  { name: '정산정보', href: '/gift-brand/settlement-info' },
  { name: '계정정보', href: '/gift-brand/settings' },
];

// 구매 흐름 체험용 데모 (새창). 임시 하드코딩 링크
const PURCHASE_DEMO_URL =
  'https://demo.preed.gaonbugo.com/gift-store?bugoId=6a221c92e8304df3a6a290fd';

// 사이드바 내부 메뉴 + 로그아웃 (모바일/데스크탑 공용)
const SidebarInner: FC<{ onNavigate?: () => void }> = ({ onNavigate }) => {
  const { pathname } = useLocation();
  const { logout, userProfile } = useAuth();

  return (
    <div className="flex h-full flex-col bg-indigo-700 text-white">
      <div className="px-5 py-5">
        <Link
          to="/gift-brand/delivery"
          onClick={onNavigate}
          className="text-lg font-bold"
        >
          답례품 배송관리자
        </Link>
      </div>
      <nav className="flex-1 space-y-1 px-3">
        {NAV_ITEMS.map((item) => {
          const active =
            pathname === item.href || pathname.startsWith(item.href + '/');
          return (
            <Link
              key={item.href}
              to={item.href}
              onClick={onNavigate}
              className={classNames(
                'block rounded-md px-3 py-3 text-base font-medium',
                active
                  ? 'bg-indigo-900 text-white'
                  : 'text-indigo-100 hover:bg-indigo-600 hover:text-white',
              )}
            >
              {item.name}
            </Link>
          );
        })}

        {/* 구매테스트 데모 (새창) */}
        <a
          href={PURCHASE_DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onNavigate}
          className="block rounded-md px-3 py-3 text-base font-medium text-indigo-100 hover:bg-indigo-600 hover:text-white"
        >
          구매테스트 데모 ↗
        </a>
      </nav>
      <div className="space-y-2 border-t border-indigo-600 px-3 py-4">
        <div className="px-1 text-sm font-medium text-white">
          {userProfile?.info?.name ?? '사용자'}님
        </div>
        <button
          onClick={() => logout()}
          className="w-full rounded-md border border-indigo-400 px-3 py-2 text-sm text-indigo-100 hover:bg-indigo-600"
        >
          로그아웃
        </button>
      </div>
    </div>
  );
};

export const GiftBrandSidebar: FC = function GiftBrandSidebar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* 모바일 상단 바 */}
      <div className="sticky top-0 z-30 flex items-center gap-3 bg-indigo-700 px-4 py-3 text-white lg:hidden">
        <button
          onClick={() => setOpen(true)}
          aria-label="메뉴 열기"
          className="rounded-md p-1 hover:bg-indigo-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <line x1="4" y1="7" x2="20" y2="7" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="17" x2="20" y2="17" />
          </svg>
        </button>
        <span className="text-base font-bold">답례품 배송관리자</span>
      </div>

      {/* 모바일 드로어 */}
      {open && (
        <div className="fixed inset-0 z-40 flex lg:hidden">
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => setOpen(false)}
          />
          <div className="relative flex w-64 max-w-[80%] flex-col">
            <SidebarInner onNavigate={() => setOpen(false)} />
          </div>
        </div>
      )}

      {/* 데스크탑 고정 사이드바 */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-60 lg:flex-col">
        <SidebarInner />
      </div>
    </>
  );
};
